import { useHistory } from "react-router-dom";

import BackHeader from "../../components/BackHeader";

import "../../styles/_carrier-links.scss";

const DirectCarrierLinks = () => {
  const history = useHistory();

  const handleBackToMenuClick = () => {
    history.goBack();
  }

  return (
    <div id="reference-tools">
      <BackHeader text="Reference Tools" onClick={handleBackToMenuClick} />
      <h1 className="mb-5">Direct Carrier Links</h1>
      <div className="carrier-links">
        <ul className="carrier-links-list">
          <li className="carrier-links-list-item">
            <h3 className="carrier-links-header">US Assure Builders Risk</h3>
            <p className="carrier-links-text">
              <b>Direct Link:</b>{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="carrier-links-link"
                href="https://usassure.com/our-programs/builders-risk"
              >
                US Assure Builders Risk
              </a>
            </p>
            <p className="carrier-links-text">
              <b>Registration:</b>{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="carrier-links-link"
                href="https://registration.usassure.com"
              >
                Register Here
              </a>
            </p>
            <p className="carrier-links-text">
              <b>Call</b>: 866-279-8253 (Choose option 1, three times)
            </p>
            <p className="carrier-links-text">
              <b>Agent Requirement</b>: Agents must know their A0Bxxxx code to set up a login.
            </p>
          </li>
          <li className="carrier-links-list-item">
            <h3 className="carrier-links-header">Bonds </h3>
            <p className="carrier-links-text">
              <b>Call Allstate Service Center</b>: (833) 250-9900 – This service line directly connects agents to Liberty and CNA bond services.
            </p>
            <p className="carrier-links-text">
              <b>Liberty Mutual</b>:{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="carrier-links-link"
                href="https://safesite.safeco.com/anonwholesale/newbusiness.aspx"
              >
                Liberty Mutual Bonds
              </a>
            </p>
            <p className="carrier-links-text">
              <b>CNA Surety Bonds</b>:{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="carrier-links-link"
                href="https://cem.cnasurety.com"
              >
                CNA Surety Bonds
              </a>
            </p>
          </li>
          <li className="carrier-links-list-item">
            <h3 className="carrier-links-header">National General</h3>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="carrier-links-link"
              href="https://www.natgenagency.com"
            >
              Agency Portal
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DirectCarrierLinks;
